import { jsx as _jsx } from "react/jsx-runtime";
import { Card, CardHeader, Col } from 'react-bootstrap';
const generateMockData = () => {
    return [
        {
            id: '1',
            label: 'Offer',
            children: [
                {
                    id: '1.1',
                    label: 'Section',
                    children: [
                        {
                            id: '1.1.1',
                            label: 'Subsection1',
                            children: [
                                {
                                    id: '1.1.1.1',
                                    label: 'Field 1.1.1.1'
                                },
                                {
                                    id: '1.1.1.2',
                                    label: 'Field 1.1.1.2'
                                }
                            ]
                        },
                        {
                            id: '1.1.2',
                            label: 'Subsection2',
                            children: [
                                {
                                    id: '1.1.1.2',
                                    label: 'Field 1.1.1.4'
                                },
                                {
                                    id: '1.1.1.3',
                                    label: 'Field 1.1.1.3'
                                }
                            ]
                        }
                    ]
                },
                {
                    id: '1.2',
                    label: 'Section 2',
                    children: [
                        {
                            id: '1.2.1',
                            label: 'Subsection 2.1',
                            children: [
                                {
                                    id: '1.2.1.1',
                                    label: 'Field 2.1.1'
                                },
                                {
                                    id: '1.2.1.2',
                                    label: 'Field 2.1.2'
                                }
                            ]
                        },
                        {
                            id: '1.2.2',
                            label: 'Subsection 2.2',
                            children: [
                                {
                                    id: '1.2.2.1',
                                    label: 'Field 2.2.1'
                                },
                                {
                                    id: '1.2.2.2',
                                    label: 'Field 2.2.2'
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            id: '2',
            label: 'Offer 2',
            children: [
                {
                    id: '2.1',
                    label: 'Section 1',
                    children: [
                        {
                            id: '2.1.1',
                            label: 'Subsection 2.1.1',
                            children: [
                                {
                                    id: '2.1.1.1',
                                    label: 'Field 2.1.1.1'
                                },
                                {
                                    id: '2.1.1.2',
                                    label: 'Field 2.1.1.2'
                                }
                            ]
                        },
                        {
                            id: '2.1.2',
                            label: 'Subsection 2.1.2',
                            children: [
                                {
                                    id: '2.1.2.1',
                                    label: 'Field 2.1.2.1'
                                },
                                {
                                    id: '2.1.2.2',
                                    label: 'Field 2.1.2.2'
                                }
                            ]
                        }
                    ]
                },
                {
                    id: '2.2',
                    label: 'Section 2',
                    children: [
                        {
                            id: '2.2.1',
                            label: 'Subsection 2.2.1',
                            children: [
                                {
                                    id: '2.2.1.1',
                                    label: 'Field 2.2.1.1'
                                },
                                {
                                    id: '2.2.1.2',
                                    label: 'Field 2.2.1.2'
                                }
                            ]
                        },
                        {
                            id: '2.2.2',
                            label: 'Subsection 2.2.2',
                            children: [
                                {
                                    id: '2.2.2.1',
                                    label: 'Field 2.2.2.1'
                                },
                                {
                                    id: '2.2.2.2',
                                    label: 'Field 2.2.2.2'
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
};
export const TreeItemTest = () => {
    const handleItemSelect = (item) => {
        console.log('Selected Item:', item);
    };
    const handleItemDrag = (item) => {
        console.log('Dragging Item:', item);
    };
    const mockData = {
        Data: generateMockData()
    };
    return (_jsx(Col, Object.assign({ md: 5 }, { children: _jsx(Card, { children: _jsx(CardHeader, { children: "Type" }) }) })));
};
